import FoxInputText from './FoxInputText';
import asReduxFormField from './asReduxFormField';
import wrapFormField from './wrapFormField';

export default wrapFormField(asReduxFormField(FoxInputText));
